<template>
  <div class="vw100 bg-w pt90 pb77 minh645 bdb-F2F2F2 column a-center">
    <div class="w-per62_5 column a-center">
      
      <div class="ft36 font-Regular c-00903B">
        {{ $t('企业动态') }}
      </div>

      <div class="w-per100 row mt43">
        <div class="flex1">
          <div class="w-per100 h50 row a-center bg-F2F2F2 ft16 font-Regular">
            <div class="px32 h-per100 row flex-center pointer"
              :class="current_index==index?'c-w bg-00903B':'c-9'"
              v-for="(item,index) in news_list" :key="index"
              @click="changeNewsTab(index)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="w-per100 mt30">
            <div class="w-per100 row a-center liBox ft16 font-Regular pointer"
              v-for="(item,index) in news_data" :key="index"
              @click="toNewsDetail(item)"
            >
              <div class="flex1 row a-center">
                <div class="dot8"></div>
                <div class="flex1 show_text dis1 lh40 ml12">
                  {{ item.name }}
                </div>
              </div>
              <div class="lh40 ml15 c-9">
                {{ item.date }}
              </div>
            </div>
          </div>
        </div>

        <div class="w-per50 h400 ml34 relative" @click.stop="changePlay">
          <video class="w-per100 h-per100" :src="getImageUrl(index_video.url)" :poster="index_video.poster" :autoplay="false"></video>
          <img class="wh80 absolute top-per50 left-per50 tr-per50 zIndex1 pointer" :src="$getAssetUrl('/pcImgs/play.png')" alt="">
        </div>
      </div>

    </div>

    <!-- 视频 -->
    <div class="videoBox fixed top-per50 left-per50 tr-per50 zIndex10" v-if="show">
      <div class="video">
        <i class="el-icon-error c-9 ft40 ml30 mt30 absolute top0 left0 zIndex20" @click.stop="changePlay"></i>
        <video class="w-per100 h-per100" controls :src="getImageUrl(index_video.url)" :poster="index_video.poster" autoplay></video>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getNewsClass, getNewsList } from "@/api/app";
export default{
  data(){
    return {
      show:false,//看视频
      news_list:[{id:1,name:this.$t('集团要闻')},{id:2,name:this.$t('业务动态')},{id:3,name:this.$t('拥军拥属')},],
      current_index:0,
      news_data:[],
      page:1,
      per_page:8,
    };
  },
  computed: {
    ...mapGetters({
      index_video:'indexVideo',
    })
  },
  mounted(){
    this._getClass();
    
  },
  methods:{
    // 切换
    changeNewsTab(index){
      this.current_index = index;
      this.page = 1;
      this._getNews();
    },
    // 播放
    changePlay(){
      this.show = !this.show;
      console.log(this.show);
    },
    // 去新闻详情
    toNewsDetail(item){
      this.$router.push({
        path: "/NDetail",
        query:{id:item.id,t:this.current_index},
      })
    },
    // 新闻 列表
    async _getNews(){
      let params = {
        category_id:this.news_list[this.current_index].id,
        page:this.page,
        per_page:this.per_page,
      }
      let {data} = await getNewsList(params);
      if(data.code == 1){
        this.news_data = data.data.data;
      }else{
        this.$message.error(data.msg);
      }
    },
    // 分类
    async _getClass(){
      let {data} = await getNewsClass();
      if(data.code == 1){
        console.log(data.data);
        this.news_list = data.data;
        this._getNews();
      }else{
        this.$message.error(data.msg);
      }
    },
  },
}
</script>

<style scoped lang="scss">
.videoBox{
  width: 48vw;
  height: 32vw;
  background: #000;
  .video{
    width: 100%;
    height: 100%;
  }
}
.liBox{
  .show_text{
    color: #333;
  }
  .dot8{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #D2D2D2;
  }
}
.liBox:hover{
  .show_text{
    color: #00903B;
  }
  .dot8{
    background-color: #00903B;
  }
}
@media screen and (min-width: 750px) and (max-width: 1250px){
.videoBox{
  width: 48vw;
  height: 32vw;
  .video{
    width: 100%;
    height: 100%;
  }
}
}
@media screen and (max-width: 750px){
.videoBox{
  width: 100vw;
  height: 100vh;
  .video{
    width: 100%;
    height: 100%;
    .el-icon-error{
      top: 18px;
      left: 16px;
      font-size: 20px;
    }
  }
}
.liBox{
  .dot8{
    width: 3px;
    height: 3px;
  }
}
}
</style>